export class DeleteResourceTagRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DataCatalogTagResourceRef",
            "format": ""
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeleteResourceTagRequest.attributeTypeMap;
    }
    constructor() {
    }
}
